/**
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns
 */
export const isEqual = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2)
}
